__turbopack_context__.v({
  "root": "AiAgentIcon-module__uJ0cBW__root",
});
